<template>
    <v-row justify='center' no-gutters>
        <v-col cols="12" md="5" lg="4" sm="10">
            <v-form ref="form" class="form-primary-text">
                <v-row class="row-height-80">
                    <v-col class="col-5 row-height-80">
                        <v-text-field
                            label="Applicant's First Name *"
                            v-model="form.first_name"
                            outlined
                            :disabled="true"
                        ></v-text-field>
                    </v-col>
                    <v-col class="col-7 row-height-80">
                        <v-text-field
                            label="Applicant's Last Name *"
                            v-model="form.last_name"
                            outlined
                            :disabled="true"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="row-height-80">
                    <v-col class="col-12 row-height-80">
                        <v-text-field
                            label="Preferred Name *"
                            v-model="form.preferred_name"
                            :rules="fullString"
                            outlined
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="row-height-80">
                    <v-col class="col-12 row-height-80">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="dateFormatted"
                                label="Date of Birth"
                                hint="Click on the year at the top of the dropdown first, then choose month and then choose day."
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @blur="date = parseDate(dateFormatted)"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                color="#ea7f1d"
                                :active-picker.sync="activePicker"
                                :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                min="1950-01-01"
                                @change="save"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12">
                        <!-- <VueGoogleAutocomplete
                            id="address"
                            label="Address *"
                            :class="populateAddress ? 'addressbox' : 'addressbox custom-error-text'"
                            placeholder="Address *"
                            :country="['au', 'nz']"                        
                            :value="populateAddress"
                            :rules="v=>!!v||'The address should not be empty'"
                            v-on:placechanged="getAddressData"
                            outlined
                        >
                        </VueGoogleAutocomplete> -->
                        <v-google-address
                            id="address"
                            label="Address *"
                            :required="true"
                            :address="populateAddress"
                            @on-address="getAddressData"
                        >
                        </v-google-address>
                    </v-col>
                </v-row>
                <v-row style="text-align: left">
                    <v-col class="col-12">
                        <span class="question">Gender *</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 no-top-padding">
                        <v-radio-group class="text-field-height-26 no-margin" v-model="form.gender" :value="form.gender" :rules="[v=> v != undefined || v != null||'Please make a selection']" row>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Male" value="Male" :style="form.gender == 'Male' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Female" value="Female" :style="form.gender == 'Female' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <!--  <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Prefer not to answer" value="Prefer not to answer" :style="form.gender == 'Prefer not to answer' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>  -->
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Other" value="Other" :style="form.gender == 'Other' ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                        </v-radio-group>   
                    </v-col>
                </v-row>
                <v-row class="row-height-80">
                    <v-col class="col-6">
                        <v-text-field
                            label="Home Phone"
                            v-model="form.home_phone"
                            outlined
                            :rules="homePhoneNumber"
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                    <v-col class="col-6">
                        <v-text-field
                            ref="repeatHomePhone"
                            label="Repeat Home Phone"
                            v-model="repeat_home_phone"
                            outlined
                            :rules="checkHomePhone"
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="row-height-80">
                    <v-col class="col-6">
                        <v-text-field
                            label="Mobile *"
                            v-model="form.mobile"
                            outlined
                            :rules="phoneNumber"
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                    <v-col class="col-6">
                        <v-text-field
                            ref="repeatMobile"
                            label="Repeat Mobile *"
                            v-model="repeat_mobile"
                            outlined
                            :rules="checkMobile"
                            @select="disableSelection($event)"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12">
                        <v-select
                            :items="contactTypes"
                            item-value="id"
                            item-text="name"
                            v-model="form.contact_type"
                            :rules="notNull"
                            label="What is the best way to contact you? *"
                            outlined
                            hide-details
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row style="text-align: left">
                    <v-col class="col-12">
                        <span class="question">Do you have any allergies? *</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 no-top-padding">
                        <v-radio-group class="text-field-height-26 no-margin" v-model="form.has_allergies" :value="form.has_allergies" :rules="[v=> v != undefined || v != null||'Please make a selection']" row>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Yes" :value="1" :style="form.has_allergies == 1 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="No" :value="0" :style="form.has_allergies == 0 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                        </v-radio-group>   
                    </v-col>
                </v-row>
                <!-- <div v-if="form.out_of_home_care"> -->
                    <v-row v-if="form.has_allergies">
                        <v-col class="col-12 col-no-up-down-padding">
                            <v-textarea
                                outlined
                                name="input-7-2"
                                v-model="form.allergies"
                                placeholder="Please provide any details about your allergies"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                <!-- </div> -->
                <v-row>
                    <v-col class="col-12">
                        <v-select
                            :items="shirtTypes"
                            item-value="id"
                            item-text="name"
                            v-model="form.shirt_type"
                            :rules="notNull"
                            label="T-Shirt Size *"
                            outlined
                            hide-details
                        ></v-select>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
    </v-row>
</template>

<script>
import Client from '../../client.js';
import Vue from 'vue'
import axios from 'axios'
// import Auto complete google map
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
import VGoogleAddress from '../VGoogleAddressComponent.vue'
import {phoneRule, hasLengthRule} from '../../utils/validationRules'

export default {

    //use as a component
    components: {VGoogleAddress},

    data: function() {
        return {
            contactTypes: null,
            shirtTypes: null,
            form: {},
            repeat_home_phone: null,
            repeat_mobile: null,
            activePicker: null,
            date: null,
            menu: false,
            dateFormatted: null,
      
        }
    },
    async mounted() {
        if(this.$parent.childName) this.$parent.childName  = 'MY PERSONAL DETAILS';
        let component = this;
        let client = Client();
        let requests = [
            client.get('contact_types'),
            client.get('me/profile?create=1'),
            client.get('shirt_types')
        ];
        let ress = await axios.all(requests);
        Vue.set(component, 'contactTypes', ress[0].data);
        Vue.set(component, 'form', ress[1].data);
        if(ress[1].data) {
            this.repeat_home_phone = ress[1].data.home_phone;
            this.repeat_mobile = ress[1].data.mobile;
            this.dateFormatted = this.formatDate(ress[1].data.dob);
        }
        this.$refs.form.resetValidation();
        Vue.set(component, 'shirtTypes', ress[2].data);
        
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
      'form.home_phone'() {
        if (this.repeat_home_phone !== null && this.repeat_home_phone !== '') {
            this.$refs.repeatHomePhone.validate();
        }
      },
      'form.mobile'() {
        if (this.repeat_mobile !== null && this.repeat_mobile !== '') {
            this.$refs.repeatMobile.validate();
        }
      }
    },
    computed: {
        checkHomePhone() {
            return [
                () => ((this.repeat_home_phone == this.form.home_phone) || (!this.repeat_home_phone && !this.form.home_phone)) || 'Home phone is not the same'
            ]
        },
        checkMobile() {
            return [
                () => this.repeat_mobile == this.form.mobile || 'Mobile is not the same'
            ]
        },
        fullString() {
            return [
                v => v !== null && v !== undefined && v.length > 1
            ]
        },
        notNull() {
            return [
                v => v !== null && v !== undefined
            ]
        },
        notEmpty() {
            return [v => Boolean(v) && v.trim().length > 0]
        },        
        homePhoneNumber() {
            return [
                phoneRule,
            ]            
        },
        phoneNumber() {
            return [
                hasLengthRule,
                phoneRule,
            ]
        },
        populateAddress() {
            return [this.form.address_street_number, this.form.address_route, this.form.address_locality, this.form.address_dministrative_area_level_2, this.form.address_administrative_area_level_1, this.form.address_country, this.form.address_postal_code].filter(Boolean).join(", ");
        },
    },
    methods: {
        disableSelection(e) {
            e.target.selectionStart = e.target.selectionEnd;
        },
        async submit() {
            let client = Client();
            if(!this.form.has_allergies) {
                this.form.allergies = null;
            }
            console.log('this.form');
            console.log(this.form);
            console.log('set school_type');
            let tmp = this.$store.getters['schtype/getschtype']['schooltype'];
            if(tmp){
                this.form.school_level = tmp;
            }
            //this.form.dob = date;
            console.log(this.form);
            return await client.patch('me/profile', this.form)
                .then(() => true)
                .catch(() => false);
        },
        getAddressData(address) {
            this.form.address_street_number = address.street_number;
            this.form.address_route=address.route;
            this.form.address_locality=address.locality;
            this.form.address_dministrative_area_level_2=address.administrative_area_level_2;
            this.form.address_administrative_area_level_1=address.administrative_area_level_1;
            this.form.address_country=address.country;
            this.form.address_postal_code=address.postal_code;
            this.form.address_latitude=address.latitude;
            this.form.address_longitude=address.longitude;
            console.log(address);
        },    
            handleError(error){
            alert(error)
        },
        save (date) {
            this.$refs.menu.save(date);
            this.form.dob = date;
            this.dateFormatted = this.formatDate(date);
            console.log(date);
        },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
    }
}
</script>

<style lang="scss" scoped>
.form-primary-text{
    font-family: Hind;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.15px;
    color: black
}

.row-height-80{
    height: 80px;
}

.row-space-10{
    margin-top:10px;
    margin-bottom: 10px;;
}

.row-top-space-38{
    margin-top:38px;
}

.row-bottom-space-100{
    margin-bottom: 100px;
}
.no-margin{
    margin:0
}
.no-top-padding{
    padding-top: 0;
}
.col-no-up-down-padding
{
    padding-top: 0;
    padding-bottom: 0;
}

</style>
